module.exports = __webpack_public_path__ + "img/customer_g_active.0fe4a202.svg";